import { useParams } from 'react-router-dom';

/**
 * @returns The schoolId from the route
 */
export const useSchoolId = () => {
  const { schoolId } = useParams<{ schoolId: string }>();
  return schoolId;
};
